import {ConfigurableChartDemoContainer} from "./ConfigurableChartDemo.elements";
import { generateDemoData } from "../util/generateDemoData";
 
import { useRouterWithHandler } from "common/hooks";
import { StatelessForm } from "common/components/StatelessForm/v2";
import { DataTable } from "common/ui/DataTables";
 import { DataObjectDisplay } from "common/ui/DataTables/DataObjectDisplay";
 
 
import { AxisChartDemos } from "./AxisChartDemos";
import { ConfigurableLineChartDemo } from "./ConfigurableLineChartDemo";




 

const ChartTypes = {
  'line': AxisChartDemos,
  'bar': AxisChartDemos
}

const demo_data_types = {
  'bars': {
    groups: ['chicken', 'steak', 'fish'],
    totals_key: 'weight', 
    grouping_key: 'recipe',
    count_key: 'count',
    interval: '1 day'
  },
  'inline-item': {
    groups: ['chicken', 'steak', 'fish'],
    totals_key: 'weight', 
    grouping_key: 'recipe',
    count_key: 'count'
  },
  'summary': {
    groups: ['chicken', 'steak', 'fish'],
    grouping_key: 'recipe',

  }
}

const demo_data = generateDemoData(demo_data_types['bars']) || {}

export const ConfigurableChartDemos = () => {
  
  const [{  data_type = 'inline-item', chart_type = 'line' }, go] = useRouterWithHandler('charts_demo/data_type/chart_type')
  
  if (chart_type === 'line') return <ConfigurableLineChartDemo />
 
  const {
    grouping_key,
    timestamp_key,
    totals_key,
    time_interval,
    data,
    count_key,
    start_time,
    end_time
  } = demo_data || {}

  const ChartComponent = ChartTypes?.[chart_type]  || (() => <div>no chart for this data type</div>)
  
 


  const chart_settings = {
    data_type,
    ...demo_data,
  }

  return (
    <ConfigurableChartDemoContainer>
      <h2 className='full'>Chart Demos</h2>
      <div className='col-l'>
        <div className='padding'>
          <div><strong>Chart Settings</strong></div>
          <StatelessForm {...{
            className:'inline-form hide-submit hide-cancel',
            handleSelect: (x) => {
              go('updatePath', x)
            },
            formFields: [{
              name: 'chart_type',
              label: 'Chart Type',
              type: 'select',
              options: Object.keys(ChartTypes),
              defaultValue: chart_type
            }]
          }}/>
        </div>
      </div>
      <div className='col-r'>
        <div className='padding'>
          <ChartComponent {...chart_settings} />
        </div>
      </div>
      <div className='data-area'>
        <div className='padding data-settings'>
          <div><strong>Demo Data Type</strong></div>
          <StatelessForm {...{
            className:'inline-form hide-submit hide-cancel',
            handleSelect: (x) => {
              go('updatePath', x)
            },
            formFields: [{
              name: 'data_type',
              label: 'Data Type',
              type: 'select',
              options: Object.keys(demo_data_types),
              defaultValue: data_type
            }]
          }}/>
          <div><strong>Data Settings</strong></div>
          <DataObjectDisplay {...{
            grouping_key,
            timestamp_key,
            totals_key,
            time_interval,
            count_key,
            start_time,
            end_time
          }} />
        </div>
        <div className='padding'>
          <div><strong>Data Sample</strong></div>
          <DataTable data={data  } />
        </div>
      </div>
    </ConfigurableChartDemoContainer>
  )
}